import CreditCardIcons from './CreditCardIcons';

export default CreditCardIcons;
